var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketImg = function SvgTicketImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ticket_img_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212123",
    d: "M22.125 7.5v2.81c-.93 0-1.69.76-1.69 1.69s.76 1.69 1.69 1.69v2.81c0 1.24-1.01 2.25-2.25 2.25H4.125c-1.24 0-2.25-1.01-2.25-2.25v-2.81c.93 0 1.69-.76 1.69-1.69s-.76-1.69-1.69-1.69V7.5c0-1.24 1.01-2.25 2.25-2.25h15.75c1.24 0 2.25 1.01 2.25 2.25M2.995 9.42c.99.43 1.69 1.42 1.69 2.58s-.69 2.11-1.69 2.58v1.92c0 .62.5 1.12 1.12 1.12h15.75c.62 0 1.12-.5 1.12-1.12v-1.92c-1-.46-1.69-1.42-1.69-2.58s.69-2.14 1.69-2.58V7.5c0-.62-.5-1.12-1.12-1.12H4.125c-.62 0-1.12.5-1.12 1.12v1.92zm3.38.33c0-.62.5-1.12 1.12-1.12h9c.62 0 1.12.5 1.12 1.12v4.5c0 .62-.5 1.12-1.12 1.12h-9c-.62 0-1.12-.5-1.12-1.12zm1.12 4.5h9v-4.5h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7EC",
    d: "M16.495 9.75h-9v4.5h9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticket_img_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.875 5.25h20.25v13.5H1.875z"
  })))));
};
export default SvgTicketImg;